import { AddonTypeId } from "../constants/addons.constants";
import { Addon } from "../types";

export const getAddonFromStoreAddons = <AddonBody>(
  addons: Addon<AddonBody>[],
  addonTypeId: AddonTypeId,
) => {
  return addons?.find((addon) => addon.addon_type_id === addonTypeId);
};
